import Home from "../components/Home/Home";

const HomePage = (): JSX.Element => {
  return <Home />;
};

export default HomePage;
